export default __webpack_public_path__ + "static/media/station-schedule.4cb59bda.svg";